export interface TaskState {
}

export class Task {
    id!: number;
    taskId!: string;
    name!: string;
    progress!: number;
    total!: number;
    gold!: number;
    crystal!: number;
    elixir!: number;
    mithril!: number;
    tickets!: number;
    heroId: string | undefined;
    taskNumber!: number;
    taskNew!: boolean;
    taskType!: TaskType;
    awardReceived!: boolean;
    optionalEndsAt!:string;
    creationCoordinate!:number;
}

export class ChainTaskInfo {
    counter!: number;
    place!: number;
}

export enum TaskType {
    SCENARIO = "SCENARIO",
    DAILY = "DAILY",
    REPEATABLE = "REPEATABLE",
    SINGLE = "SINGLE"
}

export enum EventRewardType {
    CHEST = "CHEST",
    GEMS = "GEMS",
    HERO1 = "HERO1",
    HERO2 = "HERO2",
    HERO3 = "HERO3",
}

export class EventRewardDto {
    type!: EventRewardType;
    value!: number;
    optionalId!: string;
}

export class EventRewardPosition {
    from!: number;
    to!: number;
    rewards!: EventRewardDto[];
}

export class HintDto {
    histroryTitle!: string;
    history1!: string;
    history2!: string;
    history3!: string;
    adviseTitle!: string;
    advise1!: string;
    advise2!: string;
    advise3!: string;
}